import React from 'react'
import { CSSTransition } from 'react-transition-group'
import {
  NotificationPositionType,
  NotificationTypeType,
  NOTIFICATION_TOP_RIGHT,
  NOTIFICATION_TYPE_PRIMARY
} from '../../libraries/Notification'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './Notification.scss'
const rootClassName = 'component-notification'

interface NotificationProps {
  position?: NotificationPositionType
  type?: NotificationTypeType
  count?: number
  verticalOuter?: number
  horizontalOuter?: number
  className?: string
  children: React.ReactElement
}

export default function Notification(props: NotificationProps) {
  const getProps = () => {
    const p = {
      className: getMergedClassNames([
        `${rootClassName}-outer`,
        props.className
      ])
    }
    return p
  }

  const getLabel = () => {
    if (isNaN(props.count!)) return 0
    if (props.count! < 0) return '!'
    return props.count
  }

  return (
    <div {...getProps()}>
      {props.children}
      <CSSTransition
        in={getLabel() !== 0}
        classNames={rootClassName}
        timeout={300}
        unmountOnExit
      >
        <div
          className={`${rootClassName} ${rootClassName}-${props.position} ${rootClassName}-${props.type}`}
          style={{
            top: String(props.position).match(/top/)
              ? `${0 - (props.verticalOuter || 0)}px`
              : 'unset',
            right: String(props.position).match(/right/)
              ? `${0 - (props.horizontalOuter || 0)}px`
              : 'unset',
            left: String(props.position).match(/left/)
              ? `${0 - (props.horizontalOuter || 0)}px`
              : 'unset',
            bottom: String(props.position).match(/bottom/)
              ? `${0 - (props.verticalOuter || 0)}px`
              : 'unset'
          }}
        >
          {getLabel()}
        </div>
      </CSSTransition>
    </div>
  )
}

Notification.defaultProps = {
  type: NOTIFICATION_TYPE_PRIMARY,
  position: NOTIFICATION_TOP_RIGHT,
  verticalOuter: 10,
  horizontalOuter: 10
}
